export default __webpack_public_path__ + "static/contributors-04d4b79ad5ae6e6c192442db2daf45d3.png";